// setTimeout(() => {
//     document.querySelector('[data-cart-drawer-toggle]').click();
// }, 1000);

if ( !customElements.get('hoculus-cart-gifts') ) {

    const originalFetch = window.fetch;

    customElements.define(
        'hoculus-cart-gifts',
        class extends HTMLElement {
            constructor() {
                super();

                this.config = JSON.parse(this.dataset.config || '{}');
                this.cartItems = JSON.parse(this.dataset.cartItems || '[]');
                this.formId = this.dataset.formId;

                if ( !this.config?.active ) {
                    return this.remove();
                }

                this.behaviorMap = {
                    price: this.getThresholdByPrice.bind(this),
                    quantity: this.getThresholdByQuantity.bind(this)
                }

                // Elements
                this.giftProgress = document.querySelectorAll('[data-cart-message-gift-progress]');
                this.giftProgressMessageDefault = document.querySelector('[data-gift-message-default]');
                this.giftProgressMEssageSuccess = document.querySelector('[data-gift-message-success]');

                this.giftTitleEl = this.querySelector('[data-gift-title]');
                this.giftDescriptionEl = this.querySelector('[data-gift-description]');
                this.giftItemsSlider = this.querySelector('[data-gift-items-slider]');

                this.selectedGiftsInput = document.createElement('input');
                this.selectedGiftsInput.setAttribute('form', this.formId);
                this.selectedGiftsInput.setAttribute('type', 'hidden');
                this.selectedGiftsInput.setAttribute('name', 'attributes[_Gifts]'); // ! If attribute name changes, change it in the Cart Transform too
                this.appendChild(this.selectedGiftsInput);

                this.checkoutButton = document.querySelector(
                    this.getAttribute('data-checkout-button-selector')
                );

                this.init();
            }

            async init() {
                await this.getGifts();

                if ( this.gifts.length <= 0 ) {
                    return this.remove();
                }

                this.giftTitleEl.textContent = this.config.messages.giftTitle;

                await this.getThreshold();
                
                this.setMarkup();
                this.setEvents();

                if ( this.config.behavior !== 'auto' && this.gifts.length > 1 ) {
                    await this.loadSwiper();
                    this.initSlider();
                }

                this.giftProgressMessageDefault.textContent = this.config.messages.defaultProgressMessage;
                this.giftProgressMEssageSuccess.textContent = this.config.messages.successProgressMessage;

                await this.setGiftCardContainerProduct();
                
                // ! Ended up not using the fetch override (it seems to be working without). Method is still available just in case
                // this.override();
            }

            clearCartAttribute() {
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        attributes: {
                            _Gifts: ''
                        }
                    })
                }).catch(console.error);
            }

            async getGifts() {
                try {

                    const query = `#graphql
                        query Variants($ids: [ID!]!) {
                            nodes(ids: $ids) {
                                ... on ProductVariant {
                                    id
                                    product {
                                        title
                                        description
                                        featuredImage {
                                            altText
                                            height
                                            width
                                            url
                                        }
                                    }
                                }
                            }
                        }
                    `;

                    const ids = getVariantIdsToFetch.call(this);

                    const response = await fetch(`https://${window.Shopify.shop}/api/${window.hoculus.globalSettings.api.storefrontApiVersion}/graphql.json`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ query, variables: { ids } })
                    });

                    const data = await response.json();

                    this.gifts = data.data?.nodes || [];

                } catch (err) {
                    console.error(err);
                }

                function getVariantIdsToFetch() {
                    if ( this.config.type === 'auto' ) {
                        return [this.config.gift];
                    }

                    if ( this.config.type === 'pick-gift' ) {
                        return [...this.config.giftList];
                    }

                    if ( this.config.type === 'auto-pick-gift' ) {
                        return [
                            this.config.gift,
                            ...this.config.giftList
                        ];
                    }
                }
            }

            async getItems() {
                if (this.cartItems.length === 0) {
                    const cart = await this.getCart();
                    this.cartItems = cart.items;
                }

                this.items = this.config.collection.length > 0 ? this.cartItems.filter(item => this.config.collection.includes(`gid://shopify/Product/${item.product_id}`)) : this.cartItems;
            }

            getTotal() {
                this.total = (this.items || []).reduce((acc, item) => {
                    if ( `gid://shopify/ProductVariant/${item.variant_id}` === this.config.giftContainerProductVariant || item.gift_card ) {
                        return acc;
                    }

                    if ( this.config.behavior === 'price' ) {
                        return acc + item.final_line_price / 100;
                    }

                    if ( this.config.behavior === 'quantity' ) {
                        return acc + item.quantity;
                    }
                }, 0);
            }

            async getThreshold() {
                // Filtered items that match the items in config.collection. If config.collection is empty, this.cartItems is returned
                await this.getItems();
                this.getTotal();

                const strategy = this.behaviorMap[this.config.behavior];

                if ( !strategy ) {
                    return;
                }

                strategy();

                const description = this.threshold?.message || this.config.messages.defaultGiftDescription;
                this.setGiftDescription(description, this.leftToReach);
                this.setProgressMessage();
            }

            getThresholdByPrice() {
                const sorted = [...this.config.thresholds].sort((t1, t2) => t2.thresholdPrice - t1.thresholdPrice);
                const index = sorted.findIndex(threshold => this.total >= threshold.thresholdPrice);
                this.threshold = sorted[index];

                const nextThreshold = sorted[index - 1] || this.threshold || sorted.at(-1);
 
                this.finalThresholdReached = this.threshold === nextThreshold;

                this.leftToReach = (nextThreshold.thresholdPrice - this.total).toFixed(2);
                this.setGiftProgress(nextThreshold.thresholdPrice);
            }

            getThresholdByQuantity() {
                const sorted = [...this.config.thresholds].sort((t1, t2) => t2.thresholdQuantity - t1.thresholdQuantity)
                const index = sorted.findIndex(threshold => this.total >= threshold.thresholdQuantity);
                this.threshold = sorted[index];

                const nextThreshold = sorted[index - 1] || this.threshold || sorted.at(-1);

                this.finalThresholdReached = this.threshold === nextThreshold;
                
                this.leftToReach = nextThreshold.thresholdQuantity - this.total;
                this.setGiftProgress(nextThreshold.thresholdQuantity);
            }

            getMarkup() {
                const template = this.querySelector('[data-gift-item-markup]');

                return this.gifts.reduce((markup, variant, index) => {
                    const { product } = variant;

                    const giftItemClone = template.content.cloneNode(true);

                    const giftItemEl = giftItemClone.querySelector('[data-gift-item]');
                    const imageEl = giftItemClone.querySelector('[data-gift-item-image]');
                    const titleEl = giftItemClone.querySelector('[data-gift-item-title]');
                    const descriptionEl = giftItemClone.querySelector('[data-gift-item-description]');
                    const selectEl = giftItemClone.querySelector('[data-gift-item-select]');
                    const labelEl = giftItemClone.querySelector('[data-gift-item-label]');

                    // Setting gift item
                    if ( !this.threshold ) {
                        giftItemEl.classList.add('disabled');
                    }

                    // Setting image
                    const { url, altText, width, height } = product.featuredImage;
                    imageEl.setAttribute('src', url);
                    imageEl.setAttribute('width', width);
                    imageEl.setAttribute('height', height);
                    imageEl.setAttribute('alt', altText || '');

                    // Setting title
                    titleEl.textContent = product.title;

                    // Setting description
                    descriptionEl.textContent = product.description;

                    // Setting select
                    if ( this.config.gift === variant.id ) {
                        // Auto gift has no select, it will be selected automatically if user is eligible for gift
                        giftItemClone.querySelector('.gift-item__select').remove();
                        giftItemEl.classList.add('auto');
                        if ( this.threshold ) {
                            giftItemEl.classList.add('active');
                        }
                    } else {
                        const id = `gift-${index}`;
                        selectEl.setAttribute('id', id);
                        selectEl.setAttribute('value', variant.id);
                        labelEl.setAttribute('for', id);
                    }

                    const wrapper = document.createElement('div');
                    const slide = document.createElement('div');
                    slide.classList.add('swiper-slide');
                    slide.appendChild(giftItemClone);
                    wrapper.appendChild(slide);

                    return markup +  wrapper.innerHTML;
                }, '');
            }

            setMarkup() {
                this.giftItemsSlider.innerHTML = this.getMarkup();
            }

            setGiftDescription(message = '', value = '') {
               this.giftDescriptionEl.textContent = message.replace('[]', value); 
            }

            setProgressMessage() {
                if ( this.finalThresholdReached ) {
                    this.giftProgressMessageDefault.classList.add('is-hidden');
                    this.giftProgressMEssageSuccess.classList.remove('is-hidden');
                } else {
                    this.giftProgressMessageDefault.classList.remove('is-hidden');
                    this.giftProgressMEssageSuccess.classList.add('is-hidden');
                }
            }

            setEvents() {
                this.addEventListener('change', this.onGiftChange.bind(this));
                document.addEventListener('hoculus:cart:update', this.onCartUpdate.bind(this));
            }

            onGiftChange(e) {
                const target = e.target;

                if ( !target.matches('[data-gift-item-select]') ) {
                    return;
                }

                target.closest('.gift-item').classList.toggle('active', target.checked);

                this.setStates();
                this.setGiftIds();
            }

            async onCartUpdate(e) {
                const { cartItems } = e.detail;
                this.cartItems = cartItems;

                await this.getThreshold();
                this.setStatesOnCartUpdate();
                this.setGiftIds();

                await this.setGiftCardContainerProduct();     
            }

            async setGiftCardContainerProduct() {
                const cart = await this.getCart();

                const giftContainer = cart.items.find(item => item.variant_id.toString() === this.config.giftContainerProductVariant.split('/').at(-1));

                try {
                    this.checkoutButton.disabled = true;
                    if ( this.threshold && !giftContainer ) {
                        await this.addGiftContainerProduct();
                    } else if ( !this.threshold && giftContainer ) {
                        await this.updateGiftContainerProductQuantity();
                    } else if (giftContainer?.quantity > 1) {
                        await this.updateGiftContainerProductQuantity(1);
                    }
                } catch (err) {
                    console.log('Error');
                } finally {
                    this.checkoutButton.disabled = false;
                }
            }

            async addGiftContainerProduct() {
                const id = this.config.giftContainerProductVariant.split('/').at(-1);

                const formData = new FormData();
                formData.append('form_type', 'product');
                formData.append('utf8', '✓');
                formData.append('quantity', '1');
                formData.append('id', id);
                formData.append('properties[_Gift]', 'true');
                formData.append('product-id', this.config.giftContainerProductId);
                // formData.append('section-id', '');

                return window.cart.addToCart(formData);
            }

            async updateGiftContainerProductQuantity(quantity = 0) {
                const containerId = this.config.giftContainerProductVariant.split('/').at(-1);
                const cart = await this.getCart();
                const { key } = cart.items.find(item => item.variant_id.toString() === containerId) || {};

                if (!key) {
                    return;
                }

                return window.cart.updateCart({
                    id: key,
                    quantity
                }, null, true);
            }

            setStates() {
                const count = this.getActiveGifts().length;

                if ( count >= this.threshold.value ) {
                    this.querySelectorAll('.gift-item:not(.active):not(.auto)').forEach(item => item.classList.add('disabled'));
                } else {
                    this.querySelectorAll('.gift-item.disabled').forEach(item => item.classList.remove('disabled'));
                }
            }

            setStatesOnCartUpdate() {
                if ( !this.threshold ) {
                    return this.querySelectorAll('.gift-item').forEach(item => {
                        item.classList.remove('active');
                        item.classList.add('disabled');

                        uncheckSelect(item);
                    });
                }

                const giftAutoEl = this.querySelector('.gift-item.auto');
                if ( giftAutoEl ) {
                    giftAutoEl.classList.remove('disabled');
                    giftAutoEl.classList.add('active');
                }

                if ( this.config.behavior === 'auto' || this.gifts.length <= 1 ) {
                    return;
                }

                const activeGifts = [...this.getActiveGifts()];
                const count = activeGifts.length;

                if ( count < this.threshold.value ) {
                    return this.querySelectorAll('.gift-item.disabled').forEach(item => item.classList.remove('disabled'));
                }

                activeGifts.slice(this.threshold.value).forEach(item => {
                    item.classList.remove('active');
                    item.classList.add('disabled');

                    uncheckSelect(item);
                });

                function uncheckSelect(item) {
                    const checkbox = item.querySelector('input[type="checkbox"]');

                    if ( checkbox ) {
                        checkbox.checked = false;
                    }
                }
            }

            getActiveGifts() {
                return this.querySelectorAll('.gift-item.active:not(.auto)');
            }

            setGiftIds() {
                const ids = [...this.getActiveGifts()]
                    .map(item => {
                        const giftId = item.querySelector('input[data-gift-item-select]').value;
                        return giftId;
                    }).join(',');

                this.selectedGiftsInput.setAttribute('value', ids);
            }

            setGiftProgress(threshold) {
                const progress = Math.min((this.total * 100) / threshold, 100);

                this.giftProgress.forEach((el, index) => {
                    if ( index === 0 ) {
                        el.setAttribute('value', progress);
                    }

                    el.style.setProperty('--progress-width', `${progress}%`);
                });
            }

            loadSwiper() {
                return Promise.all([
                    window.hoculus.utils.getCssAsync(window.hoculus.assets.css.swiper),
                    window.hoculus.utils.getScriptAsync(window.hoculus.assets.js.swiper),
                ]);
            }

            initSlider() {
                new Swiper('.hoculus.cart-gifts .swiper', {
                    slidesPerView: 1.33,
                    spaceBetween: 16
                });
            }

            async getCart() {
                try {
                    const response = await originalFetch('/cart.js');
                    const cart = await response.json();
                    return cart;
                } catch (err) {
                    console.log(err);
                }
            }

            override() {
                const _this = this;

                window.fetch = new Proxy(originalFetch, {
                    async apply(target, thisArg, args) {
                        const [input, config] = args;
                        const url = typeof input === 'string' ? input : input?.url;

                        if ( !isCart(url) ) {
                            return Reflect.apply(target, thisArg, args);
                        }

                        const body = config.body;

                        if ( body instanceof FormData ) {
                            // This handles product add via product form
                            // Always setting quantity to 0 so product can't be added via forms

                            const data = Object.fromEntries(body.entries());
                            
                            if ( `gid://shopify/ProductVariant/${data.id}` === _this.config.giftContainerProductVariant ) {

                                const formData = new FormData();

                                for ( const [key, value] of body.entries() ) {

                                    if ( key === 'quantity' ) {
                                        formData.append(key, '0');
                                    } else {
                                        formData.append(key, value);
                                    }

                                }

                                config.body = formData;

                            }
                        } else if ( typeof body === 'string' ) {
                            // Body can be returned as
                            // { line: 1, quantity: 2 } - when updating the quantity
                            // {
                            //     "items": [
                            //         {
                            //             "id": 53391162114381,
                            //             "quantity": 1,
                            //         }
                            //     ]
                            // } - when adding product via fetch

                            try {
                                const cart = await _this.getCart();
                                
                                const data = JSON.parse(body);

                                if ( data ) {
    
                                    let variantId = cart.items[data.line - 1]?.variant_id; // Getting the id when quantity is updated
                                    let newBody = data;

                                    if ( variantId ) { // Line quantity change
                                        newBody = {
                                            ...data, quantity: 1 // Hard coding quantity to 1
                                        }
                                    } else { // Product added via fetch

                                        // Checking if the products that are being added contains the gift product
                                        const item = data?.items?.find(item => `gid://shopify/ProductVariant/${item.id}` === _this.config.giftContainerProductVariant);
    
                                        if ( item ) {
                                            // If gift product is found in added items, check if product is already in cart
                                            variantId = item.id;
                                            const giftContainer = cart.items.find(item => `gid://shopify/ProductVariant/${item.id}` === _this.config.giftContainerProductVariant);

                                            if ( giftContainer ) {
                                                item.quantity = 0; // If gift product is already in cart, set quantity to 0
                                            }
                                        }
                                    }
    
                                    if ( variantId && `gid://shopify/ProductVariant/${variantId}` === _this.config.giftContainerProductVariant ) {
                                        
                                        config.body = JSON.stringify(newBody);
    
                                    }

                                }

                            } catch (err) {
                                console.log('Error', err);
                            }

                        }

                        return Reflect.apply(target, thisArg, args);
                    }
                });

                function isCart(url) {
                    return '/cart/add.js,/cart/update.js,/cart/change.js'.includes(url);
                }
            }
        }
    );

}